<template>
    <a class="btn-annotation btn-step-by-step"
       href="#"
       :style="data.styleRect"
       @click.prevent="updateSlide"
       v-show="data.isShow && isShowAnnot(props.annot.t)"
    >
        <img :src="`${bookInfoState.publicPath}/${props.annot.iconSrc}`"
             v-if="props.annot.iconSrc"
        >
    </a>
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, nextTick}  from "vue";
    import {useParser} from "@/modules/reader/annotations/parser";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {useAnnotationHelper} from "@/modules/reader/annotations/annotationHelper";
    import cssvar from '@/scss/_variables.scss';

    const {getResizedAnnotationPos, styleAnnotationBtn, isShowAnnot} = useAnnotationHelper();

    export default {

        props: {
            annot:Object,
            sharedMeta:Object,
            pagenum:Number
        },
        setup(props, context) {

            const { parserState, readData} = useParser();
            const { bookInfoState} = useBookInfo();
            const { pageResizeState} = usePageResize();

            const data = reactive({
                styleRect:computed(()=>{
                    let domPos = props.annot.domPos;
                    return {
                        ...getResizedAnnotationPos(domPos),
                        ...styleAnnotationBtn()
                    }
                }),
                isShow:computed(()=>{

                    let currentPageStepProgress = bookInfoState.stepByStepProgress[props.pagenum];
                    let targetRectId = props.annot.targetRectId;

                    if (props.annot.protocol === "showPrevious") {
                        if (!currentPageStepProgress) {
                            return false;
                        } else {
                            if (currentPageStepProgress[targetRectId] !== undefined) {
                                return currentPageStepProgress[targetRectId] >= 0;
                            } else {
                                return false;
                            }
                        }
                    } else {

                        if (currentPageStepProgress && currentPageStepProgress[targetRectId] !== undefined) {
                            if (!data.isLoop) {
                                return currentPageStepProgress[targetRectId] < data.stepCount - 1;
                            } else {
                                return true;
                            }
                        }

                        return true;
                    }

                }),
                stepCount:computed(()=>{
                    return props.annot.imgSrcList.length;
                }),
                isLoop:computed(()=>{
                    return props.sharedMeta[props.annot.targetRectId]["showPrevious"] === undefined;
                })
            });

            const updateSlide = ()=>{


                if (!bookInfoState.stepByStepProgress[props.pagenum]) {
                    bookInfoState.stepByStepProgress[props.pagenum] = {};
                }

                let currentPageStepProgress = bookInfoState.stepByStepProgress[props.pagenum];
                let targetRectId = props.annot.targetRectId;


                if (currentPageStepProgress[targetRectId] === undefined) {
                    currentPageStepProgress[targetRectId] = -1;
                }

                if (props.annot.protocol === "showNext") {

                    if (data.isLoop) {
                        if (currentPageStepProgress[targetRectId] === data.stepCount -1) {
                            currentPageStepProgress[targetRectId] = -1;
                        } else {
                            currentPageStepProgress[targetRectId]++;

                        }
                    } else {
                        currentPageStepProgress[targetRectId]++;
                    }

                } else {
                    currentPageStepProgress[targetRectId]--;
                }

                //console.log('step: ' +  currentPageStepProgress[targetRectId]);
            }

            return {
                props,
                data,
                pageResizeState,
                bookInfoState,
                parserState,
                updateSlide,
                isShowAnnot
            }

        }
    }

</script>


<style scoped lang="scss">


</style>